module.exports = __webpack_public_path__ + "static/media/database-white.c3be3609.svg";